import { ApplicationState, Milestone, AppPhase } from './types';

const PHASE_BY_MILESTONE: Map<Milestone, AppPhase> = new Map();
PHASE_BY_MILESTONE.set(Milestone.Src, AppPhase.Create);
PHASE_BY_MILESTONE.set(Milestone.Bin, AppPhase.Compile);
PHASE_BY_MILESTONE.set(Milestone.Db, AppPhase.Init);
PHASE_BY_MILESTONE.set(Milestone.Backend, AppPhase.Backend);
PHASE_BY_MILESTONE.set(Milestone.Running, AppPhase.Start);
PHASE_BY_MILESTONE.set(Milestone.Stopped, AppPhase.Stop);
PHASE_BY_MILESTONE.set(Milestone.Erased, AppPhase.Destroy);
PHASE_BY_MILESTONE.set(Milestone.Ping, AppPhase.Ping);

// Utility to get Phase by Milestone. All Milestones have corresponding Phases, but not vice versa.
export const getPhase = (milestone: Milestone): AppPhase => {
    return PHASE_BY_MILESTONE.get(milestone)!;
}

export const getPendingMilestonesNoTimedout = (state: ApplicationState): Milestone[] => {
    if (!state.application) {
        return [];
    }
    return state.application.getPendingMilestones().filter(milestone => !state.phases[getPhase(milestone)].timedout);
}

export const getTimedoutPhases = (state: ApplicationState): AppPhase[] => {
    if (!state.application) {
        return [];
    }
    return Object.values(AppPhase).filter(phase => state.phases[phase].timedout);
}

export const hasTimedoutPhases = (state: ApplicationState): boolean => {
    if (!state.application) {
        return false;
    }
    return getTimedoutPhases(state).length > 0;
}

